import { ShippingReport } from '@apple/assets/icons';
import { useTranslation } from '@apple/lib/i18next';
import { Link } from '@apple/ui/link/Link';

export function ShipmentReportLink(storeEventId: string) {
	const { t } = useTranslation('store-event');

	return (
		<Link
			to={'/store-events/$storeEventId/shipment-report'}
			params={{ storeEventId }}
			search={{ hideHeaderAndSidebar: true }}
			target='_blank'
		>
			<ShippingReport tooltip={t('storeEvents.actions.shipmentReport')} />
		</Link>
	);
}
